import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    this.handleReload = this.handleReload.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('TheClearAudit Error Boundary caught:', error, errorInfo);
  }

  handleReload() {
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: '40px 20px',
            textAlign: 'center',
            background: 'var(--bg)',
          }}
        >
          {/* Warning icon */}
          <div
            style={{
              width: 72,
              height: 72,
              borderRadius: 18,
              background: 'var(--red-bg)',
              border: '1px solid rgba(239,68,68,0.35)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 24,
              color: 'var(--red)',
            }}
          >
            <svg
              width="36"
              height="36"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
          </div>

          <div
            style={{
              fontSize: 22,
              fontWeight: 700,
              color: 'var(--text)',
              marginBottom: 10,
            }}
          >
            Something went wrong
          </div>

          <div
            style={{
              fontSize: 14,
              color: 'var(--text3)',
              lineHeight: 1.65,
              maxWidth: 380,
              marginBottom: 28,
            }}
          >
            An unexpected error occurred. Your compliance data is safe and has not been lost.
            Please refresh the page to continue.
          </div>

          <button
            onClick={this.handleReload}
            style={{
              background: 'var(--accent)',
              color: '#fff',
              border: 'none',
              padding: '12px 28px',
              borderRadius: 8,
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
              marginBottom: 16,
              fontFamily: 'var(--font)',
            }}
          >
            Refresh Page
          </button>

          <div style={{ fontSize: 12, color: 'var(--text3)' }}>
            If this keeps happening, contact{' '}
            <a
              href="mailto:theclearaudit@gmail.com"
              style={{ color: 'var(--accent)', textDecoration: 'none' }}
            >
              theclearaudit@gmail.com
            </a>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
